export default "__VITE_ASSET__CzDfO$Z4__"